var _ellipse, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 54,
    viewBox: "0 0 58 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.9999,
    cy: 16.2,
    rx: 7.73333,
    ry: 7.2,
    fill: "#3BAF29"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7427 31.2335C57.0149 32.1521 57.2211 33.8276 56.2034 34.9758L48.3367 43.8507C47.8126 44.4421 47.0341 44.804 46.1963 44.8459C45.3585 44.8878 44.5406 44.6057 43.9472 44.0702L40.0139 40.5202C38.8619 39.4804 38.8619 37.7946 40.0139 36.7549C41.166 35.7151 43.0338 35.7151 44.1858 36.7549L45.7859 38.199L51.5963 31.6493C52.614 30.5011 54.4704 30.3149 55.7427 31.2335Z",
    fill: "#3BAF29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M42.1994 34.4047L41.8439 34.8181C40.3628 34.4081 38.6935 34.7474 37.5242 35.836C35.8254 37.4177 35.8254 39.982 37.5242 41.5636L37.5468 41.5846C35.2165 42.5955 32.2414 43.2018 29.0001 43.2018C21.5259 43.2018 15.4668 39.9782 15.4668 36.0018C15.4668 32.0253 21.5259 28.8018 29.0001 28.8018C35.4427 28.8018 40.8338 31.1968 42.1994 34.4047Z",
    fill: "#3BAF29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCheck);
export default __webpack_public_path__ + "static/media/userCheck.14a0b2d4e4efdc4e17972476edd97fe4.svg";
export { ForwardRef as ReactComponent };